/**
 * @generated SignedSource<<37476754bb2a637da6c6ff2fc4f5aa4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ComponentTemplateDialog_rootRef$data = {
  readonly componentTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ComponentTemplateLibrary_template">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
  readonly template?: {
    readonly content: string;
    readonly habitPrompt: string | null | undefined;
    readonly id: string;
    readonly image: string | null | undefined;
    readonly private: boolean;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"ComponentTemplatePreview_template">;
  } | null | undefined;
  readonly " $fragmentType": "ComponentTemplateDialog_rootRef";
};
export type ComponentTemplateDialog_rootRef$key = {
  readonly " $data"?: ComponentTemplateDialog_rootRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"ComponentTemplateDialog_rootRef">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "componentTemplates"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentSlug"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentType"
    },
    {
      "defaultValue": 99,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "templateId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "withTemplate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./ComponentTemplateDialogRefetchQuery.graphql')
    }
  },
  "name": "ComponentTemplateDialog_rootRef",
  "selections": [
    {
      "condition": "withTemplate",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "template",
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "templateId"
            }
          ],
          "concreteType": "ComponentTemplate",
          "kind": "LinkedField",
          "name": "componentTemplate",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "habitPrompt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "private",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ComponentTemplatePreview_template"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "componentTemplates",
      "args": null,
      "concreteType": "ComponentTemplateConnection",
      "kind": "LinkedField",
      "name": "__ComponentTemplateDialog_componentTemplates_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ComponentTemplateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ComponentTemplate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ComponentTemplateLibrary_template"
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Root",
  "abstractKey": null
};
})();

(node as any).hash = "5a7f5675ced6ad3d00a71d114545ccea";

export default node;
